import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import Component from '../../dispatcher/modules/component/Component';
import RouterUtil from './RouterUtil';
import {
  APP_SETTINGS 
} from '../../dispatcher/authentication/services/AuthSettings';
import Configuration from '../../dispatcher/config/Configuration';
import { AuthService } from '../../dispatcher/authentication';
import { AUTH_ROUTER } from './Types';

class AuthRouter extends Component<AUTH_ROUTER, {}> {
  constructor(props: AUTH_ROUTER) {
    super(props);
    RouterUtil.addRoutes(props.config);
  }

  render() {
    const { config = [], children = [] } = this.props;
    let isAuthenticated = AuthService.isAuthenticatedAsync() || RouterUtil.matchRoute(config);
    let toCfg = {
      pathname: APP_SETTINGS.login_uri,
      state: { 
        route: Configuration.getPathname()
      } // writes last route into history state
    };

    return (
      <Switch>
        {/* AUTH navigation should only have root redirects */}
        {RouterUtil.redirectRoute('/', true)}

        {RouterUtil.renderChildren(children)} {/* render all the children */}
        {RouterUtil.renderRoutes(config)} {/* render all the routes */}

        {/* if user is not authenticated and there is no familiar route then go to login page */}
        {!isAuthenticated ? <Redirect
          from={'/*'}
          exact={true}
          to={toCfg}
        /> : null}
      </Switch>
    );
  }
}

export default AuthRouter;
